import { FC, forwardRef } from 'react';

import { CheckIcon, ClockArrowUp, IterationCw, Loader2Icon, TriangleAlertIcon } from 'lucide-react';

import { cn } from '@/utils';

import TrackerStateIconSkipPact from './TrackerStateIconSkipPact';

export type TrackerStateIconProps = {
  type: 'success' | 'pending' | 'error' | 'loading' | 'skipped' | 'refunded';
} & React.SVGProps<SVGSVGElement>;

const TrackerStateIcon: FC<TrackerStateIconProps> = forwardRef(({ type, className, ...props }, ref) => {
  const commonClassNames = 'text-muted-foreground mx-auto size-4';
  const commonProps = { strokeWidth: 2.5, ref, ...props };

  switch (type) {
    case 'success':
      return <CheckIcon color="green" className={cn(commonClassNames, className)} {...commonProps} />;
    case 'pending':
      return <ClockArrowUp color="darkgoldenrod" className={cn(commonClassNames, className)} {...commonProps} />;
    case 'error':
      return <TriangleAlertIcon color="#f05656" className={cn(commonClassNames, className)} {...commonProps} />;
    case 'loading':
      return <Loader2Icon className={cn('animate-spin', commonClassNames, className)} {...commonProps} />;
    case 'skipped':
      return <TrackerStateIconSkipPact className={cn(commonClassNames, className)} {...commonProps} />;
    case 'refunded':
      return <IterationCw color="green" className={cn(commonClassNames, className)} {...commonProps} />;
    default:
      return '?';
  }
});

TrackerStateIcon.displayName = 'TrackerStateIcon';

export default TrackerStateIcon;
